import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-32 md:py-40 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=stunning%20modern%20commercial%20interior%20design%20space%20warm%20ambient%20lighting%20luxury%20reception%20lounge%20stone%20wall%20texture%20wood%20floor%20elegant%20sophisticated%20atmosphere%20dark%20rich%20tones&width=1920&height=800&seq=cta001&orientation=landscape"
          alt="預約商業空間諮詢"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/65"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 text-center">
        <p className="text-[#b8956a] text-sm font-medium tracking-[0.25em] uppercase mb-6">
          Start Your Project
        </p>
        <h2
          className="text-white font-bold leading-[1.25] mb-6"
          style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)' }}
        >
          準備好打造一個更有價值的<br />商業空間了嗎？
        </h2>
        <p
          className="text-white/70 max-w-xl mx-auto mb-10 leading-relaxed"
          style={{ fontSize: '1.1875rem' }}
        >
          從免費初步諮詢開始，我們協助你釐清方向、
          規劃預算、設計落地，讓每一分投入都值得。
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-10 py-4 bg-[#b8956a] text-white font-semibold rounded-full whitespace-nowrap hover:bg-[#a07d58] transition-colors duration-300 cursor-pointer text-[1.0625rem]"
          >
            <i className="ri-calendar-check-line"></i>
            預約免費諮詢
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center gap-2 px-10 py-4 border border-white/40 text-white font-medium rounded-full whitespace-nowrap hover:bg-white/10 transition-colors duration-300 cursor-pointer text-[1.0625rem]"
          >
            <i className="ri-gallery-line"></i>
            查看設計案例
          </Link>
        </div>
      </div>
    </section>
  );
}
